import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }

  /**
   * Update free shipping progress bar when cart changes
   */
  updateFreeShippingBar(cartTotal) {
    const freeShippingBar = this.querySelector('[data-free-shipping-bar]');
    if (!freeShippingBar) return;

    // Get threshold from data attribute or settings
    const thresholdElement = document.querySelector('[data-free-shipping-threshold]');
    const threshold = thresholdElement 
      ? parseInt(thresholdElement.dataset.freeShippingThreshold) 
      : 6000; // Default 60€ in cents

    const remaining = threshold - cartTotal;
    const progressPercentage = Math.min((cartTotal / threshold) * 100, 100);

    // Update progress bar
    const progressBar = freeShippingBar.querySelector('[data-progress-bar]');
    if (progressBar) {
      progressBar.style.width = `${progressPercentage}%`;
    }

    // Update message
    const messageElement = freeShippingBar.querySelector('.cart-drawer__free-shipping-message');
    if (messageElement && remaining > 0) {
      const remainingAmount = Shopify.formatMoney(remaining, window.theme?.moneyFormat || '{{amount}}');
      const messageTemplate = messageElement.dataset.message || 'Te quedan {amount} para el envío gratis!';
      messageElement.textContent = messageTemplate.replace('{amount}', remainingAmount);
    } else if (messageElement && remaining <= 0) {
      messageElement.textContent = messageElement.dataset.successMessage || '¡Felicidades! Tienes envío gratis';
      messageElement.classList.add('cart-drawer__free-shipping-message--success');
    }
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
